import { useEffect, useRef } from 'react';
import { trackArchiveViewed } from '../application/analyticsTracker';

interface UseArchiveViewTrackingParams {
  archiveAui?: string;
  enabled: boolean;
}

export const useArchiveViewTracking = ({
  archiveAui,
  enabled,
}: UseArchiveViewTrackingParams): void => {
  const trackedArchiveAuiRef = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled || !archiveAui) return;
    if (trackedArchiveAuiRef.current === archiveAui) return;

    const timeoutId = window.setTimeout(() => {
      if (trackedArchiveAuiRef.current === archiveAui) return;
      trackedArchiveAuiRef.current = archiveAui;
      void trackArchiveViewed(archiveAui);
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [archiveAui, enabled]);
};
